import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import {
  setAuthUserDataLoading,
  setAuthUserData,
  setUserDetailsList,
  setUserDetailsListError,
  setUserDetailsListLoading,
} from "../redux/login";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { useParams, useSearchParams } from "react-router-dom";
// import { errorMessage } from "../lib/helper";
// import { setAuthUserData, setAuthUserDataLoading } from "../redux/auth";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export const LoginUser = (payload, extraConfig) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setAuthUserDataLoading(true));

        const response = await axios.post(
          `${ApiConfig.authLogin}`,
          payload,
          extraConfig
        );

        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          const responseData = response?.data?.data || {};
          const isAgentLogin = responseData?.userDetail?.user_type === 2;
          const emailVerificationPending = responseData?.email_verified === false;

          if (emailVerificationPending) {
            const email = responseData?.email || responseData?.userDetail?.email;
            localStorage.setItem("email_verified", JSON.stringify(email));
            localStorage.setItem("agentEmail", email || "");
            dispatch(setAuthUserDataLoading(false));
            toast.success(
              response?.data?.message ||
                "Please verify your email before login. We have sent OTP to your registered email.",
              {
                autoClose: 2500,
                className: "toast-message",
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            return { success: true, data: responseData, emailVerificationPending: true };
          }

          localStorage.removeItem("token");
          localStorage.removeItem("user");
          if (isAgentLogin) {
            localStorage.removeItem("agent_token");
            localStorage.removeItem("agent_user");
          }

          dispatch(setAuthUserData(responseData?.userDetail));
          if (responseData?.token) {
            localStorage.setItem("token", responseData?.token);
          }
          if (responseData?.userDetail) {
            localStorage.setItem("user", JSON.stringify(responseData?.userDetail || {}));
          }
          if (isAgentLogin && responseData?.token) {
            localStorage.setItem("agent_token", responseData?.token);
            localStorage.setItem(
              "agent_user",
              JSON.stringify(responseData?.userDetail || {})
            );
          }

          const toastId = "user-logged-in";
          toast.success(
            `Congratulations ${responseData?.userDetail?.first_name} !! You have Successfully logged In.`,
            {
              autoClose: 2500,
              className: "toast-message",
              position: toast.POSITION.TOP_RIGHT,
              toastId,
            }
          );

          dispatch(setAuthUserDataLoading(false));

          const navigate = extraConfig?.navigate;
          if (navigate) {
            const redirectRaw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
            if (redirectRaw) {
              try {
                const { path, state } = JSON.parse(redirectRaw) || {};
                localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
                if (path) {
                  if (state) {
                    navigate(path, { state });
                  } else {
                    navigate(path);
                  }
                } else {
                  navigate(isAgentLogin ? "/agent-dashboard" : "/my-property");
                }
              } catch (err) {
                console.error("Error parsing post login redirect:", err);
                navigate(isAgentLogin ? "/agent-dashboard" : "/my-property");
              }
            } else {
              navigate(isAgentLogin ? "/agent-dashboard" : "/my-property");
            }
          }
          return { success: true, data: responseData };
        } else {
          throw response;
        }
      } catch (e) {
        if (e.status == 422) {
          toast.error(e.data.message.error, {
            autoClose: 2500,
          });
          dispatch(setAuthUserDataLoading(false));
          return false;
        } else {
          toast.error(errorMessage(e), {
            autoClose: 2500,
          });
          dispatch(setAuthUserDataLoading(false));
          return false;
        }
      }
    };
  }
};

export const verifyEmailOtp = async (otp, email) => {
  if (!email || !otp) {
    toast.error("Email and OTP are required", { autoClose: 2000 });
    return false;
  }

  try {
    const response = await axios.post(
      `${ApiConfig.verifyEmailOtp}?email=${email}&otp=${otp}`
    );
    if (response.status >= STATUS_200 && response.status < STATUS_300) {
      return true;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e) || "Invalid OTP, please try again.", {
      autoClose: 2500,
    });
    return false;
  }

};

// LoginUser after not verified
export const verifyEmailOtpLogin = async (otp, email) => {
  if (!email || !otp) {
    toast.error("Email and OTP are required", { autoClose: 2000 });
    return false;
  }

  try {
    const response = await axios.post(
      `${ApiConfig.verifyEmailOtpLogin}?email=${email}&otp=${otp}`
    );

    if (response.status >= STATUS_200 && response.status < STATUS_300) {
      localStorage.setItem("agent_token", response?.data?.data?.token);
      localStorage.setItem(
        "agent_user",
        JSON.stringify(response?.data?.data?.userDetail || {})
      );
      return response?.data?.data?.userDetail;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e) || "Invalid OTP, please try again.", {
      autoClose: 2500,
    });
    return false;
  }
};

export const resendEmailOtp = async (email) => {
  if (!email) {
    toast.error("Email is required", { autoClose: 2000 });
    return false;
  }

  try {
    const response = await axios.post(
      `${ApiConfig.resendEmailOtp}?email=${email}`
    );
    if (response.status >= STATUS_200 && response.status < STATUS_300) {
      return true;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e) || "Invalid OTP, please try again.", {
      autoClose: 2500,
    });
    return false;
  }
};

export const socialLoginService = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setAuthUserDataLoading(true));
      const response = await axios.get(
        `${ApiConfig.socialLogin}google`,
        payload
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        window.open(response?.data?.url, "_self");
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setAuthUserDataLoading(false));
      return false;
    }
  };
};

export const getUserDetailsService = async (token) => {
  try {
    const response = await axios.get(`${ApiConfig.userDetails}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
      localStorage.setItem("token", token);
      localStorage.setItem(
        "user",
        JSON.stringify(response?.data?.data?.userDetail || {})
      );
      return response;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
    return false;
  }
};
export const getUserAllDetailsService = async (token) => {
  try {
    const response = await axios.get(`${ApiConfig.userDetails}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
      return response;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });

    return false;
  }
};

export const SignUpUser = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.authSignup}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // toast.success(
        //   `Heyy ${response?.data?.data?.name}! we've sent a OTP to your registered email address.`,
        //   {
        //     autoClose: 2500,
        //     className: "toast-message",
        //     position: toast.POSITION.TOP_RIGHT,
        //   }
        // );
        toast.success(response?.data?.message);
        // dispatch(setAuthUserDataLoading(false));
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      if (e?.data?.data?.email) {
        toast.error(e?.data?.data?.email[0], {
          autoClose: 2500,
        });
      } else if (e?.data?.data?.contact_number) {
        toast.error(e?.data?.data?.contact_number[0], {
          autoClose: 2500,
        });
      } else {
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
      }
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};

export const VerifyOtpForSignup = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.authSignup}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        toast.success(
          `Heyy ${response?.data?.data?.name}! Verified Successfully.`,
          {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        // dispatch(setAuthUserDataLoading(false));
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};

export const LoginAgent = (payload, extraConfig) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setAuthUserDataLoading(true));
        const response = await axios.post(
          `${ApiConfig.agentLogin}`,
          payload,
          extraConfig
        );
        if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
          localStorage.removeItem("agent_token");
          localStorage.removeItem("agent_user");
          localStorage.removeItem("email_verified");
          const responseData = response?.data?.data;
          localStorage.setItem(
            "email_verified",
            JSON.stringify(responseData?.email)
          );
          dispatch(setAuthUserData(response?.data?.data?.userDetail));
          localStorage.setItem("agent_token", response?.data?.data?.token);
          localStorage.setItem(
            "agent_user",
            JSON.stringify(response?.data?.data?.userDetail || {})
          );
          // toast.success(
          //   `Congratulations ${response?.data?.data?.userDetail?.first_name} !! You have Successfully logged In.`,
          //   {
          //     autoClose: 2500,
          //     className: "toast-message",
          //     position: toast.POSITION.TOP_RIGHT,
          //   }
          // );
          dispatch(setAuthUserDataLoading(false));
          return { success: true, data: responseData };
        } else {
          throw response;
        }
      } catch (e) {
        if (e?.status == 401) {
          toast.error(
            e?.data?.message ||
              "Agent login failed. Please check your credentials and try again.",
            {
              autoClose: 2500,
            }
          );
          dispatch(setAuthUserDataLoading(false));
          return false;
        }
        if (e.status == 422) {
          toast.error(e.data.message.error, {
            autoClose: 2500,
          });
          dispatch(setAuthUserDataLoading(false));
          return false;
        } else {
          toast.error(errorMessage(e), {
            autoClose: 2500,
          });
          dispatch(setAuthUserDataLoading(false));
          return false;
        }
      }
    };
  }
};
export const ForgotPassword = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.authForgotPwd}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        // localStorage.setItem("update_pwd_token", response?.data?.data?.token);

        toast.success(`We have sent a link to your registered Email address.`, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        // dispatch(setAuthUserDataLoading(false));
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e.data.message), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
export const UpdateNewPassword = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      // dispatch(setAuthUserDataLoading(true));
      const response = await axios.post(
        `${ApiConfig.authUpdatePwd}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        // dispatch(setAuthUserData(response?.data?.data?.userDetail));
        // localStorage.removeItem("update_pwd_token");
        localStorage.removeItem("email");

        toast.success(`Success! Your password has been changed!`, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        // dispatch(setAuthUserDataLoading(false));
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
export const ContactUsService = async (payload, extraConfig) => {
  if (payload !== undefined) {
    // return async (dispatch) => {
    try {
      const response = await axios.post(
        `${ApiConfig.contactUs}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e.data.message), {
        autoClose: 2500,
      });
      // dispatch(setAuthUserDataLoading(false));
      return false;
    }
  }
  // }
};
